// Note that these are backticks.

const MainTemplate = `
    <div>
    <menu-bar v-if="logged" v-on:setLocale="setLocale"></menu-bar>
    <div class="content">
        <router-view v-show="logged"></router-view>
    </div>
    <auth v-if="!logged" @login-result="loginResult" v-on:setLocale="setLocale"></auth>
    </div>
`

export { MainTemplate }


// WEBPACK FOOTER //
// ./src/app/js/main-template.js